module.exports = __webpack_public_path__ + "img/agave-historia.b4dcbf69.jpg";